import "./PulseCircle.scss";

export const PulseCircle = () => {
  return (
    <div className="PulseCircle">
      <div className="PulseCircle-Dot"><span></span></div>
    </div>
  );
};
